import React, { memo } from 'react'

import { HiLockClosed } from 'react-icons/hi2'
import { twMerge } from 'tailwind-merge'

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/common/TooltipV3'

interface CuiOrgIndicatorProps {
  className?: string
  side?: React.ComponentProps<typeof TooltipContent>['side']
}

export const CuiOrgIndicator: React.FC<CuiOrgIndicatorProps> = memo(
  ({ className, side = 'top' }) => (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <span
          aria-label="CUI-enabled organization"
          className={twMerge(
            'inline-flex items-center justify-center shrink-0 text-green-500 dark:text-green-500',
            className,
          )}
        >
          <HiLockClosed className="w-3.5 h-3.5" />
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-72" side={side}>
        This organization is configured to handle Controlled Unclassified
        Information (CUI).
      </TooltipContent>
    </Tooltip>
  ),
)

CuiOrgIndicator.displayName = 'CuiOrgIndicator'
